import { NPS_BUCKETS } from "./constants";
import { SATISFACTION_STOPS } from "@/lib/chartPalettes";

/**
 * Predefined color palettes for per-choice coloring in Results V2 charts.
 * Each palette has a `generate(codes)` function that returns a { code: hex } map.
 */

/**
 * Linearly interpolate between two hex colors.
 */
function lerpColor(a, b, t) {
  const parse = (hex) => [
    parseInt(hex.slice(1, 3), 16),
    parseInt(hex.slice(3, 5), 16),
    parseInt(hex.slice(5, 7), 16),
  ];
  const [r1, g1, b1] = parse(a);
  const [r2, g2, b2] = parse(b);
  const r = Math.round(r1 + (r2 - r1) * t);
  const g = Math.round(g1 + (g2 - g1) * t);
  const bl = Math.round(b1 + (b2 - b1) * t);
  return `#${((1 << 24) | (r << 16) | (g << 8) | bl).toString(16).slice(1)}`;
}

/**
 * Generate a gradient across codes: red → yellow → green (or reverse).
 */
function satisfactionGradient(codes, reverse = false) {
  const { low: red, mid: yellow, high: green } = SATISFACTION_STOPS;
  const map = {};
  const n = codes.length;
  if (n === 0) return map;
  if (n === 1) {
    map[codes[0]] = yellow;
    return map;
  }
  codes.forEach((code, i) => {
    const t = i / (n - 1);
    const effectiveT = reverse ? 1 - t : t;
    // First half: red → yellow, second half: yellow → green
    const color =
      effectiveT <= 0.5
        ? lerpColor(red, yellow, effectiveT * 2)
        : lerpColor(yellow, green, (effectiveT - 0.5) * 2);
    map[code] = color;
  });
  return map;
}

export const CHOICE_COLOR_PALETTES = [
  {
    id: "satisfaction",
    label: "Satisfaction (red \u2192 green)",
    generate: (codes) => satisfactionGradient(codes, false),
  },
  {
    id: "satisfaction_reverse",
    label: "Satisfaction (green \u2192 red)",
    generate: (codes) => satisfactionGradient(codes, true),
  },
  {
    id: "nps",
    label: "NPS",
    generate: (codes) => {
      const [red, yellow, green] = NPS_BUCKETS.map((b) => b.color);
      const map = {};
      codes.forEach((code) => {
        const num = parseInt(code, 10);
        if (!isNaN(num)) {
          if (num <= 6) map[code] = red;
          else if (num <= 8) map[code] = yellow;
          else map[code] = green;
        } else {
          map[code] = yellow;
        }
      });
      return map;
    },
  },
];
